module.exports = __webpack_public_path__ + "media/palenque/mayan_roof-9b08b80c.jpg";